<template>
  <div class='airConfigWrap'>
    <div class='airConfigTitle'>空调列表</div>
    <div class='airConfigList'>
      <div class='commonItem airConfigItem' v-for='item in airConfigList' :key='item.serId' @click='getAirConfig(item.serId,item.status)'>
        <div :class='["airConfigStatus",{airConfigStatusActive:item.status==1}]'>{{item.status==1?'在线':'离线'}}</div>
        <div class='airConfigImg'></div>
        <div class='airConfigName'>{{item.serName}}</div>
      </div>
    </div>
    <el-dialog 
      :title="`${airConfigInfo.serName}空调机配置信息`" 
      :visible.sync="isShow" 
      :close-on-click-modal='false'
      :custom-class='"dialog-setBg dialog-airConfig-bg"'>
      <div class='fromWrap'>
        <el-form ref="airConfigInfo" :model="airConfigInfo" label-width="120px" class='airConfigForm' :rules='saveAirConfigRules'>
          <div class='dialog-setWrap dialog-airConfig-wrap'>
            <el-form-item label="空调站号" prop='acStnum'>
              <el-input v-model.number="airConfigInfo.acStnum" placeholder="请输入1-255的数字"></el-input>
            </el-form-item>
              <el-form-item label="通信站号" prop='stnum'>
              <el-input v-model.number="airConfigInfo.stnum" placeholder="请输入1-255的数字"></el-input>
            </el-form-item>
            <el-form-item label="自动上传周期" prop='upPeriod'>
              <el-input v-model.number="airConfigInfo.upPeriod" placeholder="请输入5-120的数字"><i slot="suffix" style="font-style:normal;margin-right:5x;font-size:14px">s</i></el-input>
            </el-form-item>
            <el-form-item label="通讯超时时间" prop='overTime'>
              <el-input v-model.number="airConfigInfo.overTime" placeholder="请输入100-10000的数字"><i slot="suffix" style="font-style:normal;margin-right:5x;font-size:14px">ms</i></el-input>
            </el-form-item>
            <el-form-item label="闸门开启时间" prop='openTime'>
              <el-input v-model.number="airConfigInfo.openTime" placeholder="请输入10-300的数字"><i slot="suffix" style="font-style:normal;margin-right:5x;font-size:14px">s</i></el-input>
            </el-form-item>
            <el-form-item label="闸门配置" prop='ctrlSluice'>
              <el-radio-group v-model="airConfigInfo.ctrlSluice">
                <el-radio :label="1">有闸门</el-radio>
                <el-radio :label="0">无闸门</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="关联闸门" prop='acSluice' v-if='airConfigInfo.ctrlSluice==1'>
              <el-radio-group v-model="airConfigInfo.acSluice">
                <el-radio :label="1">关联</el-radio>
                <el-radio :label="0">不关联</el-radio>
              </el-radio-group>
            </el-form-item>
          </div>
          <el-form-item class='saveBtn'>
            <el-button type="primary" @click="saveAirConfig('airConfigInfo')" style='margin-bottom:20px'>保存</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import axios from '../../axios.js'
export default {
  props:{
    wareId:Number
  },
  data(){
    const checkNum=(rule, value, callback) => {
      if(rule.field=='acStnum'||rule.field=='stnum'){
        if(value>256||value<1){
          callback(new Error('请输入1-255的数字'));
        }else{
          callback()
        }
      }else if(rule.field=="upPeriod"){
         if(value>120||value<5){
          callback(new Error('请输入5-120的数字'));
        }else{
          callback()
        }
      }else if(rule.field=="overTime"){
        if(value>10000||value<100){
          callback(new Error('请输入100-10000的数字'));
        }else{
          callback()
        }
      }else if(rule.field=='openTime'){
        if(value>300||value<10){
          callback(new Error('请输入10-300的数字'));
        }else{
          callback()
        }
      }
    }
    return{
      airConfigList:[],
      isShow:false,
      serId:'',
      airConfigInfo:{},
      loading:'',
      newWareId:this.wareId,
      saveAirConfigRules:{
        acStnum:[
          {trigger:'blur',message:'空调站号不能为空',required:true},
          {trigger:'change',message:'空调站号必须为数字',type:'number'},
          {trigger:'blur',validator:checkNum}
        ],
        upPeriod:[
          {trigger:'blur',message:'时间不能为空',required:true},
          {trigger:'change',message:'时间必须为数字',type:'number'},
          {trigger:'blur',validator:checkNum}
        ],
        stnum:[
          {trigger:'blur',message:'通信站号不能为空',required:true},
          {trigger:'change',message:'通信站号必须为数字',type:'number'},
          {trigger:'blur',validator:checkNum}
        ],
        overTime:[
          {trigger:'blur',message:'时间不能为空',required:true},
          {trigger:'change',message:'时间必须为数字',type:'number'},
          {trigger:'blur',validator:checkNum}
        ],
        openTime:[
          {trigger:'blur',message:'时间不能为空',required:true},
          {trigger:'change',message:'时间必须为数字',type:'number'},
          {trigger:'blur',validator:checkNum}
        ]
      }
    }
  },
  created(){
    this.getAirConfigList()
  },
  watch: {
    wareId(newV, oldV) { 
      this.newWareId=newV;
      this.getAirConfigList()
    }
  },
  methods:{
    getAirConfigList(){
      axios.get(`/system/air/getAirByWareId/${this.newWareId}`).then(data=>{
        this.airConfigList=data.data;
      })
    },
    getAirConfig(serId,status){
      if(status==1){
        this.isShow=true;
        this.serId=serId;
        axios.get(`/system/air/getAirBySerId/${this.serId}`).then(data=>{
          this.airConfigInfo=data.data;
          this.airConfigInfo.acSluice.toString()
        })
      }else{
        this.$message({
          message:'不能配置离线设备！',
          type:'error',
          duration:1000
        })
      }
    },
    // 设置加载动画
    setConfigLoading(){
      this.loading=this.$loading({
        text:'请稍等',
        target:document.querySelector('.dialog-airConfig-bg')
      })
    },
    saveAirConfig(obj){
      this.$refs[obj].validate((valid)=>{
        if(valid){
          this.airConfigInfo.serId=this.serId;
          this.setConfigLoading()
          axios.post('/system/air/upsetAirSystem',this.airConfigInfo).then(data=>{
            this.loading.close()
            if(data){
              this.$message({
                message:data.msg,
                type:'success',
                duration:1000,
              })
              this.isShow=false
            }
          })
        }else{
          return false
        }
      })
    }
  }
}
</script>

<style>
  .airConfigWrap{
    padding: 15px;
    box-sizing: border-box
  }
  .airConfigTitle{
    font-size: 14px;
    font-weight: 600;
    color: rgba(0,0,0,0.6);
    padding-left: 20px;
  }
  .airConfigList{
    padding: 20px;
    box-sizing: border-box;
  }
  .airConfigItem{
    width: 220px;
    height: 220px;
    margin-right: 40px;
    margin-bottom: 40px;
    cursor: pointer;
  }
  .airConfigStatus{
    width: 80px;
    height: 36px;
    line-height: 36px;
    border-top-right-radius: 8px;
    border-bottom-left-radius: 4px;
    position: absolute;
    right: 0;
    top: 0;
    font-size: 14px;
    font-weight: 600;
    text-align: center;
    background-color: rgba(121,121,121,0.12);
    color: #AFAFAF
  }
  .airConfigStatusActive{
    background-color: rgba(81,255,53,0.12);
    color: #3BD14A
  }
  .airConfigImg{
    height: 89px;
    width: 132px;
    background-image: url('../../assets/air/air.png');
    background-size: cover
  }
  .airConfigName{
    height: 36px;
    font-size: 16px;
    font-weight: 600;
    text-align: center;
    position: absolute;
    bottom: 0;
  }
  .dialog-airConfig-bg{
    width: 740px !important;
  }
  .dialog-airConfig-wrap{
    flex-wrap: wrap;
    width:700px;
  }
  .airConfigFormItem{
    width: 50%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 20px 15px 0px 10px;
    height: 100%;
    box-sizing: border-box;
  }
</style>